  <div class='personalization-cta w-100' data-test="personalization-cta">
    <div class='background-image w-100 h-100 px-3 px-lg-4 py-3'>
      <div class='d-flex justify-content-between'>
        <div class='d-flex position-relative'>
          <div class='avatar-wrapper overflow-hidden'>
            <div class="d-flex justify-content-center align-items-center mx-2 px-1 mb-2 mb-lg-0">
              <img data-test='personalization-cta-image'
                src='{{ image }}'
                class="no-skeleton"
                loading="lazy"
              >
              <div class='shadow-border'></div>
            </div>
          </div>

          <div class='position-absolute star-container'>
            <div class='dashed-circle d-flex align-items-center justify-content-center'>
              <div class="svg-wrapper svg-vertical-align-middle">
                <flo-svg-icon class="grey-500" icon="icon-star-filled" width="1.25em"></flo-svg-icon>
              </div>
            </div>
          </div>

          <div class='d-flex flex-column justify-content-center pb-2 px-3 ps-lg-4'>
            <h2 data-test='personalization-cta-title'
              class='color-100 m-0'>{{ title }}</h2>
            <div class='color-400 fw-normal' data-test='personalization-cta-subtitle'>{{ subtitle }}</div>
          </div>
        </div>

        <!-- desktop button -->
        <div class='d-none d-md-flex align-items-center'>
          <button data-test='personalization-cta-btnTitle-desktop'
            floAnalytics name='Personalization CTA Desktop'
            (click)='onCtaClick()'
            class='btn btn-primary'>{{ btnTitle }}</button>
        </div>

      </div>

      <!-- Mobile button -->
      <div class='d-flex justify-content-center mt-3 d-md-none'>
        <button data-test='personalization-cta-btnTitle-mobile'
          floAnalytics name='Personalization CTA Mobile'
          (click)='onCtaClick()'
          class='btn btn-primary w-100'>{{ btnTitle }}</button>
      </div>

    </div>
</div>
